module.exports = __webpack_public_path__ + "img/no.413a6828.svg";